<ng-container *ngIf="permConfig.isViewAllowed">
<div class="container-fluid">
    <app-page-title title="Reports"></app-page-title>
    <form [formGroup]="reportForm">
        <div class="row">
            <div class="col-md-12">

                <div class="card">
                    <ngb-accordion #a="ngbAccordion" class="accordion range-accordion">
                        <ngb-panel id="1">
                            <ng-template ngbPanelTitle class="text-black">
                                <i class="bx bx-search text-primary me-1"></i> Search and filter your reports
                            </ng-template>
                            <ng-template ngbPanelContent>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="category" class="form-label">Category<span
                                                        class="mandatory">*</span></label>
                                                <ng-select id="category" placeholder="Select" [items]="categoryOptions"
                                                    bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlCategory" (change)="bindType()"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || reportForm.get('ddlCategory')?.touched) && reportForm.get('ddlCategory').errors}"  >
                                                </ng-select>
                                                <div *ngIf="(isFormSubmitted || reportForm.get('ddlCategory')?.touched) && reportForm.get('ddlCategory').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="reportForm.get('ddlCategory').errors.required">Category
                                                        is
                                                        required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="reporttype" class="form-label">Type<span
                                                        class="mandatory">*</span></label>
                                                <ng-select id="reporttype" placeholder="Select" [items]="typeOptions"
                                                    bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlType" (change)="bindReport()"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || reportForm.get('ddlType')?.touched) && reportForm.get('ddlType').errors}"  >
                                                </ng-select>
                                                <div *ngIf="(isFormSubmitted || reportForm.get('ddlType')?.touched) && reportForm.get('ddlType').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="reportForm.get('ddlType').errors.required">Type is
                                                        required</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="reports" class="form-label">Reports<span
                                                        class="mandatory">*</span></label>
                                                <ng-select id="reports" placeholder="Select" [items]="reportOptions"
                                                    bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlReports" (change)="onReportChange($event)"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                                    [ngClass]="{'is-invalid': (isFormSubmitted || reportForm.get('ddlReports')?.touched) && reportForm.get('ddlReports').errors}"  >
                                                </ng-select>
                                                <div *ngIf="(isFormSubmitted || reportForm.get('ddlReports')?.touched) && reportForm.get('ddlReports').errors"
                                                    class="invalid-feedback">
                                                    <span *ngIf="reportForm.get('ddlReports').errors.required">Report is
                                                        required</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="fromdate" class="form-label">From Date</label>
                                                <input type="date" id="fromdate" class="form-control form-control-sm"
                                                    formControlName="txtFromDate"  >
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="todate" class="form-label">To Date</label>
                                                <input type="date" id="todate" class="form-control form-control-sm"
                                                    formControlName="txtToDate"  >
                                            </div>
                                        </div>
                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label for="customer" class="form-label">Customer </label>
                                                <ng-select id="customer" placeholder="Select" [items]="customerList"    
                                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCustomer" bindLabel="name"
                                                    [bindValue]="'id'"
                                                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"  >
                                                </ng-select>
                                            </div>
                                        </div>                                        

                                        <div class="col-md-2" *ngIf="!showZeroReports || !showVOIDReports">
                                            <div class="mb-2">
                                                <label for="product" class="form-label">Product Type</label>
                                                <ng-select id="product" [items]="productTypeList" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlProductType"  ></ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports || showDeliveryReports || showDailyReports || showZeroReports || showVOIDReports">
                                            <div class="mb-2">
                                                <label for="bindProduct" class="form-label">Product</label>
                                                <ng-select id="bindProduct" [items]="productList" placeholder="Select"
                                                bindLabel="name" [bindValue]="'id'"
                                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlProduct"  ></ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showZeroReports || showVOIDReports">
                                            <div class="mb-2">
                                                <label for="PaymentType" class="form-label">Payment Type</label>
                                                <ng-select id="PaymentType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                    [items]="paymentTypeList" formControlName="ddlPaymentType" >
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2">
                                            <div class="mb-2">
                                                <label class="form-label" for="vendor">Vendor</label>
                                                <ng-select id="vendor" [items]="vendorList" formControlName="ddlVendor"
                                                    bindLabel="name" [bindValue]="'id'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="showDeliveryReports">
                                            <div class="mb-2">
                                                <label class="form-label" for="forwardingvendor">Forwarding Vendor</label>
                                                <ng-select id="forwardingvendor" [items]="vendorList" formControlName="ddForwardinglVendor"
                                                    bindLabel="name" [bindValue]="'id'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports">
                                            <div class="mb-2">
                                                <label class="form-label" for="reportType">Report Type</label>
                                                <ng-select id="reportType" [items]= "reportTypeList" formControlName="ddlReportType"
                                                    bindLabel="type" [bindValue]="'value'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>                                        
                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports  || showInvoiceReports">
                                            <div class="mb-2">
                                                <label for="servicecenter" class="form-label">Service Center</label>
                                                <ng-select id="servicecenter" [items]="serviceCenterList" bindLabel="name"
                                                    placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlServiceCenter"   >
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports">
                                            <div class="mb-2">
                                                <label for="salesexecutive" class="form-label">Sales Executive</label>
                                                <ng-select id="salesexecutive" [items]="userList" bindLabel="username" placeholder="Select" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                                                    formControlName="ddlSalesExecutive"  >
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports || showDailyReports">
                                            <div class="mb-2">
                                                <label for="ddlCustomerType" class="form-label">Customer Type</label>
                                                <ng-select id="ddlCustomerType" [items]="customerTypeList" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlCustomerType"  ></ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="showFiledAnalysisReports">
                                            <div class="mb-2">
                                                <label for="businessType" class="form-label">Business Type</label>
                                                <ng-select id="businessType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                    [items]="businessTypeList" formControlName="ddlBusinessType"  >
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showProjectionReports">
                                            <div class="mb-2">
                                                <label for="average" class="form-label">Average</label>
                                                <ng-select id="average" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                    [items]="averageList" formControlName="ddlAverage"  >
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="showProjectionReports">
                                            <div class="mb-2">
                                                <label for="reportOn" class="form-label">Report On</label>
                                                <ng-select id="reportOn" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                    [items]="reportOnList" formControlName="ddlReportOn"  >
                                                </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showMisReports || showDeliveryReports">
                                            <div class="mb-2">
                                                <label class="form-label" for="misReportType">Report Type</label>
                                                <ng-select id="misReportType" [items]= "misReportType" formControlName="ddlMisReportType"
                                                    bindLabel="name" [bindValue]="'value'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>
                                        <div class="col-md-2" *ngIf="showDeliveryReports">
                                            <div class="mb-2">
                                                <label class="form-label" for="deliveryReportStatus">Status</label>
                                                <ng-select id="deliveryReportStatus" [items]= "deliveryReportStatus" formControlName="ddlDeliveryReportStatus"
                                                    bindLabel="name" [bindValue]="'value'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>                                       

                                        <div class="col-md-2" *ngIf="showDailyReports || showZeroReports || showVOIDReports || showInvoiceReports">
                                            <div class="mb-2">
                                              <label for="company" class="form-label">Company </label>
                                              <ng-select id="company" placeholder="Select" [items]="companyList" [appendTo]="'body'" [openOnEnter]="false"
                                                formControlName="ddlCompanies" bindLabel="name" [bindValue]="'id'"
                                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom">
                                              </ng-select>
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showVOIDReports">
                                            <div class="mb-2">
                                                <label for="awbnumber" class="form-label">AWB Number</label>
                                                <input type="text" class="form-control form-control-sm" maxlength="30" id="awbnumber"
                                                    formControlName="txtAwbNumber"/>                                                
                                            </div>
                                        </div>

                                        <div class="col-md-2" *ngIf="showInvoiceReports">
                                            <div class="mb-2">
                                                <label class="form-label" for="lockType">Lock Type</label>
                                                <ng-select id="lockType" [items]= "lockType" formControlName="ddlLockType"
                                                    bindLabel="name" [bindValue]="'value'" placeholder="Select"
                                                    [appendTo]="'body'" [openOnEnter]="false"  >
                                                </ng-select>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-6 mt-2">
                                        <div class="card">
                                            <div class="card-header bg-transparent border-bottom text-uppercase" style="box-shadow: none;border-radius: 0px !important;">Origin</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="country" class="form-label">Country</label>
                                                            <ng-select id="country" formControlName="ddlOriginCountry"
                                                                placeholder="Select" [items]="countryList"
                                                                bindLabel="name" [bindValue]="'isocode'"
                                                                [appendTo]="'body'" [openOnEnter]="false"
                                                                (change)="onCountryChange('origin')"  >
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="state" class="form-label">State</label>
                                                            <ng-select id="state" formControlName="ddlOriginState"
                                                                placeholder="Select" [items]="originStateList"
                                                                bindLabel="name" [bindValue]="'isocode'"
                                                                [appendTo]="'body'" [openOnEnter]="false"
                                                                (change)="onStateChange('origin')"  />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="city" class="form-label">City</label>
                                                            <ng-select id="city" formControlName="ddlOriginCity"
                                                                placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                                [items]="originCityList" bindLabel="name"
                                                                [bindValue]="'isocode'"  />
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6  mt-2">
                                        <div class="card">
                                            <div class="card-header bg-transparent border-bottom text-uppercase" style="box-shadow: none;border-radius: 0px !important;">
                                                Destination</div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="country" class="form-label">Country</label>
                                                            <ng-select id="country"
                                                                formControlName="ddlDestinationCountry"
                                                                placeholder="Select" [items]="countryList"
                                                                bindLabel="name" [bindValue]="'isocode'"
                                                                [appendTo]="'body'" [openOnEnter]="false" (change)="onCountryChange()"  >
                                                            </ng-select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="state" class="form-label">State</label>
                                                            <ng-select id="state" formControlName="ddlDestinationState"
                                                                placeholder="Select" [items]="destinationStateList"
                                                                bindLabel="name" [bindValue]="'isocode'"
                                                                [appendTo]="'body'" [openOnEnter]="false" (change)="onStateChange()"  />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4">
                                                        <div class="mb-2">
                                                            <label for="city" class="form-label">City</label>
                                                            <ng-select id="city" formControlName="ddlDestinationCity"
                                                                placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                                                                [items]="destinationCityList" bindLabel="name"
                                                                [bindValue]="'isocode'"  />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="alert alert-warning alert-dismissible fade show" role="alert">
                                    <i class="mdi mdi-alert-outline me-2"></i>
                                    <span>You can extract report upto 3 months.</span>
                                    <!-- <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> -->
                                </div>
                                <div class="row mt-2 mb-2">
                                    <div class="col-md-2">
                                        <div class="mb-2">
                                            <button type="button" class="btn btn-primary" (click)="filterData()" >
                                                Search
                                            </button>
                                            <button type="button" class="btn btn-secondary" (click)="resetForm()">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            </ng-template>
                        </ngb-panel>

                    </ngb-accordion>
                </div>

            </div>
        </div>
    </form>

    <div class="card">
        <div class="card-body">
            <div class="row" style="display: flex; justify-content: space-between; align-items: center;">
                <div class="col-md-3 mb-2">
                    <button type="button" class="btn btn-primary btn-sm d-flex" (click)="exportExcel()">Export
                        <i class="bx bx-download font-size-16 px-1"></i>
                    </button>
                </div>
                <div *ngIf="showButton" class="col-md-3 mb-2" style="display: flex; justify-content: end;">
                    <button type="button" class="btn btn-primary btn-sm d-flex"
                        (click)="openColumnSelectorModal()">Select Columns</button>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                        [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                        [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                        [pagination]="true" (gridReady)="onGridReady($event)">
                    </ag-grid-angular>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #columnSelectorModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Select Columns</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body" style="max-height: 600px;overflow: auto;">
        <label class="selectall">
            <input type="checkbox" [(ngModel)]="allColumnsSelected" (change)="onChangeSelectAllCheckbox($event)">
            Select/Unselect All
        </label>
        <ul class="column-selector-list">
            <li *ngFor="let colDef of columnDefs">
                <label>
                    <input type="checkbox" [(ngModel)]="colDef.visible" (change)="onColumnVisibilityChanged()"> {{
                    colDef.headerName }}
                </label>
            </li>
        </ul>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-sm" (click)="saveColumnSelection()">Save</button>
    </div>
</ng-template>
</ng-container>
<ng-container *ngIf="!permConfig.isViewAllowed">
    <app-forbidden></app-forbidden>
</ng-container>